import { makeStyles } from "@mui/styles";
import React from "react";
import { HeaderMenu } from "../components/Header";
import vision_text1 from "../asset/vision_text_img1.png";
import vision_text2 from "../asset/vision_text_img2.png";
import vision_center_new from "../asset/vision_center.png";
import { MobileWeb } from "../components/mobile/BreakPoint";
import { Theme } from "@mui/material";
import { Footer } from "../components/Footer";
import { MobileFooter } from "../components/mobile/MobileFooter";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "0px auto",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      margin: "0px",
      height: "100vh",
      minWidth: "auto",
    },
  },
  body: {
    alignItems: "center",
    width: "100%",
    maxHeight: 1114,
    minHeight: 915,
    height: "100%",
    alignSelf: "center",
    textAlign: "center",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    borderTop: "1px solid #0000003b",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "auto",
      height: "100vh",
      margin: "12px 20px",
      borderTop: "none",
    },
  },
  img_purple_circle: {
    display: "block",
    position: "relative",
    left: 389,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "20%",
      left: 20,
      top: -10,
    },
  },
  img_vision_t_1: {
    display: "block",
    position: "relative",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      width: "100%",
    },
  },
  img_vision_t_2: {
    display: "block",
    position: "relative",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      width: "100%",
    },
  },
  img_vision_center: {
    position: "relative",

    [theme.breakpoints.down(MobileWeb.mobile)]: {
      width: "100%",
    },
  },
  con1: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      position: "relative",
    },
  },
}));

const VisionPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HeaderMenu />
      <div className={classes.body}>
        <div className={classes.con1}>
          {/* <img
            src={purple_circle}
            alt="purple_circle"
            className={classes.img_purple_circle}
          /> */}
          <img
            src={vision_text1}
            alt="vision_text1"
            className={classes.img_vision_t_1}
          />
        </div>
        <div
          style={{
            background: "#fdf5fd",
            width: "100%",
            margin: "30px 0px",
            padding: "40px 0px",
          }}
        >
          <img
            src={vision_center_new}
            alt="vision_center"
            className={classes.img_vision_center}
          />
        </div>
        <div>
          <img
            src={vision_text2}
            alt="vision_text2"
            className={classes.img_vision_t_2}
          />
        </div>
        <div></div>
      </div>
      <Footer />
      <div style={{ display: "flex" }}>
        <MobileFooter />
      </div>
    </div>
  );
};

export default VisionPage;
